import { Dialog, DialogTitle, DialogContent, Table, TableBody, IconButton, TableCell, TableContainer, TableHead, TableRow, Paper, Box } from '@mui/material';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';
import CloseIcon from '@mui/icons-material/Close';

const columns = [
    { id: '#', label: '#', minWidth: 20 },
    { id: 'n_papeleta', label: 'n° Papeleta', minWidth: 60, align: 'center' },
    { id: 'fecha_salida', label: 'Fecha de Salida', minWidth: 80, align: 'center', type: 'icon' },
    { id: 'fecha_reincorporacion', label: 'Fecha de Reincorporación', minWidth: 60, align: 'center', type: 'icon' },
    { id: 'n_diasTomados', label: 'Total de Días Tomados', minWidth: 60, align: 'center', type: 'icon' },
    { id: 'fecha_registro', label: 'Fecha de Registro', minWidth: 60, align: 'center', type: 'icon' },
    { id: 'fecha_aprobacion', label: 'Fecha de Aprobación', minWidth: 60, align: 'center', type: 'icon' },
    { id: 'acciones', label: 'Acciones', minWidth: 120, align: 'center' }
];

export default function ApprovedBallotsModal({ open, onClose, papeletas, personaNombre, funcionDescargar }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth scroll="paper">
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <span>Papeletas Aprobadas de {personaNombre}</span>
                    <IconButton aria-label="cerrar" onClick={onClose}>
                        <CloseIcon color="error" />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {columns.map((col) => (
                                    <TableCell
                                        key={col.id}
                                        align={col.align || 'left'}
                                        style={{ minWidth: col.minWidth }}
                                    >
                                        {col.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {papeletas.map((row, index) => (
                                <TableRow key={`modal-row-${index}`}>
                                    {columns.map((col) => (
                                        <TableCell key={col.id} align={col.align || 'left'}>
                                            {col.id === '#' ? (
                                                index + 1
                                            ) : col.id === 'acciones' ? (
                                                <IconButton
                                                    title='Ver papeleta'
                                                    size="small"
                                                    color='info'
                                                    style={{ border: 'solid 0.02rem', borderRadius: 0 }}
                                                    onClick={() => funcionDescargar(row.id_papeleta)}
                                                >
                                                    <PictureAsPdfTwoToneIcon fontSize="inherit" />
                                                </IconButton>
                                            ) : row[col.id]
                                            }
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
}
